import { ORDER_STATUS } from "core/interfaces";

import { getCustomerDefault } from "~/common/defaults/customer.default";
import { getShippingDefault } from "~/common/defaults/shipping.default";
import type {
	Order,
	OrderAdapted
} from "~/common/interfaces/entities/order.interface";

export const getOrderDefault = (): Order => ({
	id: 0,
	subId: "",
	status: ORDER_STATUS.INIT,
	comment: "",
	callback: false,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	items: [],
	customer: getCustomerDefault(),
	shipping: getShippingDefault()
});

export const getOrderAdaptedDefault = (): OrderAdapted => ({
	id: 0,
	subId: "",
	status: ORDER_STATUS.INIT,
	comment: "",
	callback: false,
	createdAt: new Date().toLocaleString(),
	updatedAt: new Date().toLocaleString(),
	items: [],
	customer: getCustomerDefault(),
	shipping: getShippingDefault(),
	total: 0
});
